<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            PhotonLab Android App
        </h1>
        <h2 class="projectSubTitle">
            Android App Developed to Connect and Control the PhotonLab Smart Lights
        </h2>
        <p>
            Google play store: <a href="https://play.google.com/store/apps/details?id=xyz.photonlab.photonlabandroid">https://play.google.com/store/apps/details?id=xyz.photonlab.photonlabandroid</a>
        </p>
        <img style="width:20%" src="\ImgThumbNail\photon2.png">
        <img style="width:20%" src="\ImgThumbNail\photo1.png">
        <img style="width:20%" src="\ImgThumbNail\photon3.png">
        <img style="width:20%" src="\ImgThumbNail\photon4.png">
        <h3>
            Video for PhotonLab Light:
        </h3>
        <iframe width="60%" height="315" src="https://www.youtube.com/embed/y5nYd6GKnjQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </span>
  
</template>

<script>
export default {
    name:"photonLab"

}
</script>

<style>


</style>